import type { TipoAtendimento } from './enums';
import { DURACAO_SLOT_MIN, horarioDosMinutos, minutosDoHorario } from '../horario';

/** Duracao real de uma aula, por `tipoAtendimento` da matricula -- nao do professor. */
export const DURACAO_AULA_MIN: Record<TipoAtendimento, number> = {
  REGULAR: 50,
  PRE_ESCOLAR: 30,
};

/** Slots de `DURACAO_SLOT_MIN` que a aula ocupa, arredondado pra cima: `REGULAR` (50min) ocupa 2 (o horário + spillover), `PRE_ESCOLAR` (30min) ocupa 1. */
export function slotsOcupados(tipoAtendimento: TipoAtendimento): number {
  return Math.ceil(DURACAO_AULA_MIN[tipoAtendimento] / DURACAO_SLOT_MIN);
}

/** Única fonte da regra de duração (Painel e Agenda) — ex.: `REGULAR` às 14:00 devolve `['14:00', '14:30']`. */
export function horariosOcupados(
  horarioInicio: string,
  tipoAtendimento: TipoAtendimento,
): string[] {
  const slots = slotsOcupados(tipoAtendimento);
  const inicioMin = minutosDoHorario(horarioInicio);
  return Array.from({ length: slots }, (_, i) =>
    horarioDosMinutos(inicioMin + i * DURACAO_SLOT_MIN),
  );
}
